import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { isAndroid, isApple, isManyChatApp } from '@manychat/manyui'

import { UserActivationEvent, UserDisplayFlagType } from 'apps/dashboard/constants/DisplayFlagType'
import { setDisplayFlag } from 'apps/profile/actions/profileActions'
import { isProOrTrial } from 'common/core/models/Account/helpers'
import {
  getCurrentAccount,
  getIsUserHasActivationEvent,
  getUserInterfaceDataDisplayFlags,
} from 'common/core/selectors/appSelectors'
import { isPathnameInclude } from 'utils/router/tools'
import { UserFlag } from 'utils/services/featureFlagsService/constants'
import { useUserReleaseToggle } from 'utils/services/featureFlagsService/releaseTogglesHooks'
import * as sessionStorage from 'utils/sessionStorage'

import { AppBannerStorageIds } from './constants'

export const useShouldShowMobileBanner = () => {
  const [query] = useSearchParams()
  const [isBannerVisible, setIsBannerVisible] = useState(true)
  const isDashboardPage = isPathnameInclude('/dashboard')
  const dispatch = useAppDispatch()
  const isAccountProOrTrial = isProOrTrial(useAppSelector(getCurrentAccount))

  const isMobileAppInstalled = useAppSelector((state) =>
    getIsUserHasActivationEvent(state, UserActivationEvent.MOBILE_APP_INSTALLED),
  )
  const displayFlags = useAppSelector(getUserInterfaceDataDisplayFlags)
  const bannerWasHidden = displayFlags?.[UserDisplayFlagType.HIDE_MOBILE_APP_BANNER]

  const isBannerExperimentEnabled = useUserReleaseToggle(
    UserFlag.ENABLE_MOBILE_APP_BANNER_BY_RULE_EXPERIMENT,
  )

  const referrer = query.get('referrer')
  const isMobileReferrer = referrer === 'mobile-app'
  const isSessionFromMobile =
    sessionStorage.getItem(AppBannerStorageIds.DISABLE_FORCED_APP_BANNER) === 'true'

  useEffect(() => {
    if (isMobileReferrer) {
      sessionStorage.setItem(AppBannerStorageIds.DISABLE_FORCED_APP_BANNER, 'true')
    }
  }, [isMobileReferrer])

  const userHasMobileApp = isMobileAppInstalled || isMobileReferrer || isSessionFromMobile
  const isSupportedDevice = (isAndroid || isApple) && !isManyChatApp

  const shouldShowBanner =
    isDashboardPage &&
    isAccountProOrTrial &&
    isBannerExperimentEnabled &&
    isBannerVisible &&
    isSupportedDevice &&
    !userHasMobileApp &&
    !bannerWasHidden

  const closeBanner = () => {
    dispatch(
      setDisplayFlag({
        displayFlag: UserDisplayFlagType.HIDE_MOBILE_APP_BANNER,
        value: true,
      }),
    )
    setIsBannerVisible(false)
  }

  return { shouldShowBanner, closeBanner }
}
